import { FC } from 'react';
import InformativeTooltip from 'modules/events/components/InformativeTooltip';
import Box from 'yoda-ui/components/Box';
import { YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type CardHeaderProps = {
  title: string;
  tooltipTitle?: string;
  tooltipImageUrl?: string;
  children?: React.ReactNode;
};

const CardHeader: FC<CardHeaderProps> = ({ children, title, tooltipTitle, tooltipImageUrl }) => (
  <Box
    display="flex"
    alignItems="center"
    flexDirection="row"
    paddingBottom={ YodaSpacing.xxSmall }
    paddingX={ YodaSpacing.large }
    paddingY={ YodaSpacing.medium }
    fontSize={ YodaFontSize.xLarge }
    fontWeight={ YodaFontWeight.medium }
    justifyContent="space-between"
  >
    <Box display="flex" alignItems="center">
      { title }
      {
        tooltipTitle
        && <InformativeTooltip title={ tooltipTitle } imageUrl={ tooltipImageUrl } />
      }
    </Box>
    { children }
  </Box>
);

export default CardHeader;
